const Toaster = {
  NetworkErr: "Check your Internet connection",
  RepeatedBidMsg: "Repeated Bid.",
  UniqueBidMsg: "Unique Bid",
  DeSelectedBids: "Previously selected bids have been deselected.",
  NoBidAvailable: "Cannot select more than available bids.",
  BidSubmitted: "Bids submitted successfully, Check your bid status on my bid.",
  UpdateProfile: "Your profile successfully updated.",
  UpcomingAuctionMsg: "This auction isn't live yet!!",
  BuyBidsMsg: "You don't have sufficient bids.",
  "Request failed with status code 500": "Request failed with status code 500",
}

const ToasterMsg = {
  network: "Something went wrong!!",
  repeatedBid: "Repeated Bid.",
  deSelectedBids: "Previously selected bids have been deselected.",
  noBidAvailable: "Cannot select more than available bids.",
  bidSubmitted: "Bids submitted successfully.",
  updateProfile: "Your profile successfully updated.",
  upcomingAuction: "This auction isn't live yet!!",
  buyBids: "You don't have sufficient bids.",
  loginRequired: "Login required!!",
}

const HomePage = {
  Bid: "Bid",
  BidNWin: "BidNWin",
  NoAuction: "No Auction Available",
  Live: "Live",
  Upcoming: "Upcoming",
  FreeBidMsg:
    "Congratulations!! As first time user you have earned <1><0>{{count}}</0></1> free Bids, Same has been added in your account.",
  OK: "OK",
  UserNotFound: "User not found",
  CongratTitle: "Bid for your favourite products at unbelievable prices",
  Youhave: "You have",
  FreeBids: "free Bids",
  StartBidding: "Start Bidding",
  BuyBid: "Buy Bid",
  BuyBids: "Buy Bids",
  HowBid: "How does the bid work",
}

const ProductDetailPage = {
  MyBids: "My Bids", // My Bids Page
  AuctionNotLive: "Auction isn't live yet!!",
  BidsRemaining: "Bids Remaining",
  HowBidWork: "How bid works",
  KeyFeatures: "Key Features",
  PlaceBid: "Place Bid",
  MarketValue: "Market Value",
}

const PlaceBidPage = {
  ChooseRange: "Select bid range",
  BidSelected: "bid are selected",
  ConfirmBid: "Confirm your bid",
  SurePlaceBids: "Do you want to place",
  CannotSelectBid: "You cannot select bid more than",
  No: "No",
  Yes: "Yes",
  SelectBid: "Select one or more bids",
  SelectBidInfo: "The lowest unique bid will win",
  PlaceBids: "Place Bids",
  bids: "bids",
}

const MyBidsPage = {
  All: "All",
  UniqueBids: "Unique Bids",
  RepeatedBids: "Repeated Bids",
  LatestBids: "Latest Bids",
  Selected: "selected",
  NoBidsPlaced: "No bids placed",
  FirstBidPlaced: "Please place your first bid here",
  GoodBids: "Good Bids",
  BadBids: "Bad Bids",
  OkBids: "OK Bids",
}

const AccountInfoPage = {
  MyAccount: "My Account",
  AccountInfo: "Account Info",
  PersonalInfo: "Personal Info",
  MobileNumber: "Mobile Number",
  Operator: "Operator",
  Status: "Status",
  BidsAvailable: "Bids Available", // Home page
  Bids: "Bids",
  SUBSCRIBED: "SUBSCRIBED",
  UNSUBSCRIBE: "Cancel Subscription",
  TRIAL: "TRIAL",
  BidsExpiry: "Bids Expiry",
  BidsExpiryMsg: "bids will expire today",
  BUYBIDS: "BUY BIDS",
  UnsubscribeMsg:
    "Dear user, you still have remaining <1><0>{{count}}</0></1> Bids. Are you sure you want unsubscribe from the service.",
  UnsubscribeBids: "Unsubscribe Bids",
  UnsubscribeBtnTxt: "Yes, Unsubscribe",
  NoPlaceMyBids: "No, Place my Bids",
  termsAndConditions: "Terms And Conditions",
  bidnWinTermAndConditions: "Bid n Win Terms And Conditions",
  bidnWinTestimonials: "Testimonials",
  "Bid n Win Terms And Conditions": "Bid n Win Terms And Conditions",
}

const PastWinnersPage = {
  Winners: "Winners",
  PastWinners: "Past Winners",
  ListPastAuction: "List of Past Auctions",
  NoWinners: "No Winners Yet",
  WinningBid: "Winning Bid", //Winners Detail page
}

const PersonalInfoPage = {
  Profile: "Profile",
  FullName: "Full Name",
  FullNamePlaceHolder: "Enter your full name",
  EmailId: "Email ID",
  EmailPlaceHolder: "Enter your email address",
  PhoneNumber: "Phone Number",
  PhoneNumberPlaceHolder: "Enter your phone number",
  ShippingAddress: "Shipping Address",
  ShippingAddressPlaceHolder: "Enter your shipping address",
}

const TNC = {
  "LICENSE TO USE": "LICENSE TO USE 222222",
}

const Menu = {
  Home: "Home",
  PrivacyPolicy: "Privacy Policy",
  InviteEarn: "Invite and Earn",
  Wallet: "Wallet",
  Transactions: "Transactions",
  AboutUs: "About Us",
  RateUs: "Rate Us",
  ContactUs: "Contact Us",
  TNC: "Terms & Conditions",
  Transaction: "Transaction",
  Chat: "Chat",
  HTB: "How to Bid",
  BID: "Bid",
  BuyBids: "Buy Bids",
  Winners: "Winners",
  "My Account": "My Account",
}

const Text = {
  Welcome: "Welcome to Bidnwin",
  FreeBids: "Free Bids",
  HeaderMessage: "Bid and Win exciting products",
  HowToBid: "How to Bid",
  Auctions: "Auctions",
  Bid: "Bid",
  "Place Bid": "Place Bid",
  UnlimitedFreeBids: "Unlimited Free Bids",
  FreeBidsOnRegister:
    "Get Free 20 bid as soon as your friend registers on BidNWin.",
  ReferalTextMsg:
    "Hey, Invite friends & family to BidNWin & get free bids and win phones, laptops and many more click",
  QuerySuccessfullySubmitted: "Your query successfully submitted",
  NameCantBeEmpty: "Name can't be empty",
  InvalidEmailAddress: "Invalid email address",
  SelectQueryType: "Please select query type",
  MessageCatnBeEmpty: "Message can't be empty",
  Name: "Name",
  "Customer Query": "Customer Query",
  Suggestion: "Suggestion",
  Complaint: "Complaint",
  MaxMessageLenDisplay: "Message (255 characters allowed)",
  "Enter your message": "Enter your message",
  "Enter your full name": "Enter your full name",
  "Enter your email address": "Enter your email address",
  "Email Address": "Email Address",
  Submit: "Submit",
  Type: "Type",
  NoMoreSelection: "You cannot select bid more than",
  "Data Saver": "Data Saver",
  step: "step",
  step_file_type: "png",
  live_now: "live_now",
  live_now_file_type: "svg",
  MessageCantBeEmpty: "Please fill out this field.",
}

const newTexts = {
  Testimonials: "Testimonials",
  Logout: "Logout",
  Edit: "Edit",
  MyWinnings: "My Winnings",
  DeliveryAddress: "Delivery Address",
  Email: "Email",
  LiveBids: "Live Bids",
  ExpiredBids: "Expired Bids",
  Expired: "Expired",
  AllBidsPlaced: "All Bids Placed",
  AllBids: "All Bids",
  MyProfile: "My Profile",
  EditMyProfile: "Edit My Profile",
  YouWinner: "You're the winner",
  WinnerName: "Winner Name",
  MultipleBids: "Multiple Bids",
  YouBidMore: "You can bid more than one here",
  ChooseBid: "Choose Bid",
  BidsPlacedSuccessfully: "Bids placed successfully",
  UserBidSummary: "User's Bid's Summary",
  ListOfBids:
    "List of good and bad bids placed with colour categorization",
  GreenIs: "Green is",
  OrangeIs: "Red is",
  Unique: "Unique",
  RedIs: "Red is",
  NonUnique: "Non-unique",
  PlaceMoreBids: "Place More Bids",
  PlaceBidsBetween: "Place bids between",
  And: "and",
  ImproveWinningChances: "to improve your winning chances",
  SkipToHome: "Skip to Home",
  ColourLegends: "Colour Legends",
  SeeAll: "See All",
  TrendingBids: "Trending Bids",
  DailyBids: "Daily Bids",
  WeeklyBids: "Weekly Bids",
  Days: "Days",
  Day: "Day",
  KeyFeatures: "Key features",
  AuctionNotLiveYet: "Auction isn't live yet",
  BidBalance: "Bid Balance",
  ExpiredBidCount: "Expired Bid Count",
  Good: "Good",
  Okay: "Okay",
  Bad: "Bad",
}

const en = {
  translations: {
    ...HomePage,
    ...MyBidsPage,
    ...ProductDetailPage,
    ...PlaceBidPage,
    ...AccountInfoPage,
    ...PastWinnersPage,
    ...PersonalInfoPage,
    ...Toaster,
    ...TNC,
    ...Menu,
    ...Text,
    ...ToasterMsg,
    ...newTexts,
  },
}

export default en



// WEBPACK FOOTER //
// ./src/languages/en.js